import { BroadcastChannelService, BroadcastService, NullBroadcastService } from './broadcastService';

export class BroadcastEvent {
  eventType: BroadcastEventType;
}

export enum BroadcastEventType {
  LOGIN_PAGE_RENDERED,
  LAUNCHPAD_PAGE_RENDERED,
  LOGIN_ATTEMPT_RESPONSE_RECEIVED,
  LOGIN_WITH_IP_ATTEMPT_RESPONSE_RECEIVED,
}

export const CSRF_VERIFIABLE_EVENT_TYPES = [
  BroadcastEventType.LOGIN_PAGE_RENDERED,
  BroadcastEventType.LOGIN_ATTEMPT_RESPONSE_RECEIVED,
  BroadcastEventType.LAUNCHPAD_PAGE_RENDERED,
];

export function createBroadcastService(): BroadcastService {
  if ('BroadcastChannel' in self) {
    return new BroadcastChannelService();
  } else {
    console.warn('"BroadcastChannel" is not supported. Please consider updating your browser.');
    return new NullBroadcastService();
  }
}
